import { Link } from "react-router-dom";
import SectionHeading from "@/components/base/SectionHeading";
import { categories } from "@/mocks/categories";

export default function CategoryGrid() {
  return (
    <section className="w-full bg-background-100 px-4 py-14 md:px-6 md:py-20" aria-label="主题分类">
      <div className="mx-auto max-w-6xl">
        <div className="flex flex-col gap-5 md:flex-row md:items-end md:justify-between">
          <SectionHeading
            eyebrow="主题分类"
            title="按方向挑选，更容易找到对味的群"
            desc="不同的吃瓜方向对应完全不同的讨论氛围。先确定自己关心哪一类，再从对应的群里挑，命中率会高很多。"
          />
          <Link
            to="/ranking"
            className="inline-flex shrink-0 items-center gap-1.5 whitespace-nowrap font-label text-sm text-primary-600 transition-colors hover:text-primary-700"
          >
            查看全部群组
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="mt-10 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {categories.map((cat) => (
            <Link
              key={cat.id}
              to="/ranking"
              className="group flex flex-col rounded-lg border border-background-200 bg-background-50 p-5 transition-colors hover:border-accent-300"
            >
              <div className="flex items-center justify-between">
                <span className="flex h-11 w-11 items-center justify-center rounded-md bg-accent-100 text-accent-700">
                  <i className={`${cat.icon} text-xl`}></i>
                </span>
                <span className="rounded-full bg-background-100 px-3 py-1 font-label text-xs text-foreground-600">
                  {cat.groupCount} 个群组
                </span>
              </div>
              <h3 className="mt-4 font-heading text-lg text-foreground-950">{cat.name}</h3>
              <p className="mt-2 flex-1 text-sm leading-relaxed text-foreground-600">{cat.desc}</p>
              <span className="mt-4 inline-flex items-center gap-1.5 font-label text-xs text-primary-600">
                进入分类排行
                <i className="ri-arrow-right-line transition-transform group-hover:translate-x-0.5"></i>
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}